import React, { useState } from 'react';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';
import { POPUPS } from '@common/constants/popups';
import ToastWrapper from '@common/helpers/toastWrapper';
import NumericInput from '@common/components/numericInput';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { useBalance } from '../../hooks/balance';
import { getAuthData } from '@common/helpers/auth';

export const MpesaWithdraw = ({ openPopup, closePopup }) => {
  const t = useTranslation();
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const balance = useBalance();
  const { currency } = getAuthData()

  const onWithdraw = async () => {
    if (+amount > +balance)
      return ToastWrapper('error', 'Amount exceeds the available balance');

    try {
      setIsLoading(true);

      const req = {
        amount: +amount,
        service: 475,
        payee: {
          forProduct: 'sport',
          isAmountHidden: false
        },
      }

      const res = await swarmRequest(req, 'withdraw_v2');

      if (res.status === 'error')
        return ToastWrapper('error', res.message || 'Something went wrong while doing a withdrawal')

      openPopup(POPUPS.DEPOSIT_PENDING, { type: 'withdraw' });
    } catch (ex) {
      ToastWrapper('error', 'Something went wrong while withdrawing')
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="popup-content popup-small mpesa-withdraw-popup">
      <i onClick={closePopup} className="global-icon icon-Close close-popup" />
      <h3 className="popup-title">{t('M-Pesa Withdraw')}</h3>
      <p className='popup-subtitle'>{t('Please input the withdraw amount')}</p>
      <div className="popup-main-content">
        <i className='global-icon icon-cashout' />
        <div className='input-wrapper'>
          {
            <div className='amount-label-wrapper'>
              {amount && <p className="popup-txt">{t('Withdraw amount')}</p>}
              <div className='available-balance'>
                Current balance: <span>{balance} {currency}</span>
              </div>

            </div>
          }
          <div className='input-row'>
            <NumericInput
              value={amount}
              placeholder={t('Withdraw amount')}
              onChange={setAmount}
              class="popup-inp"
              maxLength={40}
              disableSearchIcon
            />
            <div className='input-right-content'>
              <span className='currency'>{currency}</span>
              <div className='max-button' onClick={() => setAmount(balance)}>Max</div>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-actions">
        <button
          className="popup-confirm-button"
          disabled={!+amount || isLoading}
          onClick={onWithdraw}
        >
          {
            t(isLoading ? 'Processing...' : 'Withdraw')
          }
        </button>
      </div>
    </div>
  )
}